<template>
  <div class="col-12">
    <hr />
    <EditorGroupToggle
      label="Online Settings"
      target="toggleGroupOnlineSettings"
      class="mb-4"
      :collapsed="false"
    />
    <div id="toggleGroupOnlineSettings" class="collapse show row">
      <div class="col-12 col-xl-4 mb-3">
        <Field
          type="select"
          name="series_id"
          label="Series"
          :value="course.series_id"
          :options="series"
        />
      </div>
      <div class="col-12 col-xl-8 mb-3">
        <SuggestMultiField
          label="Prerequisites"
          name="prerequisites"
          :value="course.prerequisite_ids"
          :search-url="route('admin.courses.prerequisite-search')"
        />
      </div>
      <div class="col-12 col-xl-3 mb-3">
        <Field
          type="text"
          name="cost"
          :label="`${costLabelPrefix} Standard Cost`"
          :value="course.cost"
          :readonly="managersOnly"
        />
      </div>
      <div class="col-12 col-xl-3 mb-3">
        <Field
          type="text"
          name="fad_cost"
          :label="`${costLabelPrefix} FAD/Elite Cost`"
          :value="course.fad_cost"
          :readonly="managersOnly"
        />
      </div>
      <div class="col-12 col-xl-3 mb-3">
        <Field
          type="text"
          name="distributor_cost"
          label="Distributor Employee Cost"
          :value="course.distributor_cost"
        />
      </div>
      <div class="d-none d-xl-flex col-xl-3"></div>
      <div class="col-12 col-xl-3 mb-3">
        <Field
          type="select"
          name="trainer_fee_type"
          label="Trainer Fee Type"
          :value="course.trainer_fee_type"
          :options="invoiceTypes"
          :hideSelectEmptyOption="true"
        />
      </div>
      <div class="col-12 col-xl-3 mb-3">
        <Field type="text" name="trainer_fee" label="Trainer Fee" :value="course.trainer_fee" />
      </div>
      <div class="d-none d-xl-flex col-xl-3"></div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    course: { type: Object, required: true },
    ownerType: { type: String },
    series: { type: Array, default: () => [] },
    invoiceTypes: { type: Array, required: true },
    managersOnly: { type: Boolean, default: false }
  },
  data() {
    return {};
  },
  computed: {
    costLabelPrefix() {
      return this.ownerType == "DISTRIBUTOR" ? "Distributor" : "Factory";
    }
  },
  mounted() {}
};
</script>